
import React, { useMemo } from 'react';
import * as MdIcons from 'react-icons/md';
import { Badge } from 'react-bootstrap';
import '../../../assets/scss/cmn.scss';

const SectorHierarchyCards = ({ sectorData, onSectorSelect, selectedCategory, onCategorySelect, selectedSector, selectedSubSector, selectedSubSubSector }) => {

  const handleSectorClick = (sector) => {
    if (selectedSector?.code === sector.code) {
      // toggle off
      onSectorSelect?.(null, null, null);
    } else {
      onSectorSelect?.(sector, null, null);
    }
  };

  const handleSubSectorClick = (subSector) => {
    if (selectedSubSector?.code === subSector.code) {
      // toggle off
      onSectorSelect?.(selectedSector, null, null);
    } else {
      onSectorSelect?.(selectedSector, subSector, null);
    }
  };

  const handleSubSubSectorClick = (subSub) => {
    if (selectedSubSubSector?.code === subSub.code) {
      // toggle off
      onSectorSelect?.(selectedSector, selectedSubSector, null);
    } else {
      onSectorSelect?.(selectedSector, selectedSubSector, subSub);
    }
  };

  const renderCard = (item, onClick, isSelected) => {
    const IconComponent = MdIcons[item.icon?.trim()] || null;

    return (
      <div className="col-12 col-sm-6 col-lg-4 mb-3" key={item.code}>
        <div
          className={`card h-100 ${isSelected ? 'bg-light border-black border-2' : ''}`}
          style={{ cursor: 'pointer' }}
          onClick={() => onClick(item)}
        >
          <div className="card-body p-3 d-flex justify-content-between align-items-center">
            <h6 className="mb-0 text-800 color-dark-blue">
              {item.name}
            </h6>
            {IconComponent && <IconComponent size={28} color="#2668f7" />}
          </div>
        </div>
      </div>
    );
  };

  // Extract all unique supertag codes and names
  const superTags = useMemo(() => {
    return sectorData.map(tag => ({
      code: tag.supertag_code,
      name: tag.supertag_name
    }));
  }, [sectorData]);

  // Filter sectors based on selected supertag
  const filteredSectors = useMemo(() => {
    if (selectedCategory === 'All') {
      return sectorData.flatMap(tag => tag.sectors);
    }
    const tag = sectorData.find(tag => tag.supertag_code === selectedCategory);
    return tag ? tag.sectors : [];
  }, [sectorData, selectedCategory]);

  return (
    <div className="mt-4">
      {/* Supertag Category Badges */}
      <div className="mb-3">
        <div className="btn-group flex-wrap" role="group">
          { sectorData.length >0 && (
          <Badge
            bg={selectedCategory === 'All' ? 'darkv' : 'secondary'}
            onClick={() => onCategorySelect('All')}
            className="me-2 mb-2 d-flex align-items-center gap-1"
            style={{ cursor: 'pointer' }}
          >
            {selectedCategory === 'All' && <span>✓</span>}
            See All
          </Badge>)}

          {superTags.map(tag => (
            <Badge
              key={tag.code}
              bg={selectedCategory === tag.code ? 'darkv' : 'secondary'}
              onClick={() => onCategorySelect(tag.code)}
              className="me-2 mb-2 d-flex align-items-center gap-1"
              style={{ cursor: 'pointer' }}
            >
              {selectedCategory === tag.code && <span>✓</span>}
              {tag.name}
            </Badge>
          ))}
        </div>
      </div>

      {/* Sector Cards */}
      {filteredSectors.length > 0 && (
      <h5 className="mb-3">Sectors</h5>
      )}
      <div className="row">
        {filteredSectors.map(sector =>
          renderCard(sector, handleSectorClick, selectedSector?.code === sector.code)
        )}
      </div>

      {/* Sub-sector Cards */}
      {selectedSector && selectedSector.sub_sectors.length>0 && (
        <>
          <h6 className="mt-3">Sub-sectors of {selectedSector.name}</h6>
          <div className="row">
            {selectedSector.sub_sectors.map(sub =>
              renderCard(sub, handleSubSectorClick, selectedSubSector?.code === sub.code)
            )}
          </div>
        </>
      )}

      {/* Sub-sub-sector Cards */}
      {selectedSubSector && selectedSubSector.sub_sub_sectors.length>0 && (
        <>
          <h6 className="mt-3">Sub-sub-sectors of {selectedSubSector.name}</h6>
          <div className="row">
            {selectedSubSector.sub_sub_sectors.map(subsub =>
              //renderCard(subsub, () => {}, false)
              renderCard(
                subsub,
                () => handleSubSubSectorClick(subsub),
                selectedSubSubSector?.code === subsub.code
              )
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SectorHierarchyCards;
